import React, { Component } from 'react';
import { MegadraftIcons, MegadraftPlugin } from 'megadraft';
import md from 'megadraft';
import PluginButton from './PluginButton';
import BlockComponent from './BlockComponent';

export default {
  // Friendly plugin name
  title: 'Youtube',
  // A unique plugin name used to identify the plugin and its blocks
  type: 'youtube-video',
  // React component to be rendered in the block sidebar
  buttonComponent: PluginButton,
  // React component for rendering the content block
  blockComponent: BlockComponent,
  // options: {
  //   defaultDisplay: "center",
  //   displayOptions: [
  //     {"key": "center", "icon": MegadraftIcons.MediaMediumIcon, "label": "CENTER"},
  //     {"key": "left", "icon": MegadraftIcons.MediaSmallIcon, "label": "LEFT"}]
  // }
};
